import React from 'react';
import ClaimType from "../common/ClaimType";
import SelectDropdown from "../../input/SelectDropdown";
import { findPossessiveFor, PartOfSpeech } from "../../common/PersonalLanguage";
import { BeneficiaryMakingClaimTo } from "../../enums/BeneficiaryMakingClaimTo";
import { FormValues } from "../../common/FormValues";
import { useFormikContext } from "formik";
import DateInput from "../../input/DateInput";

const BeneficiaryClaimType = () => {
    const { values } = useFormikContext<FormValues>();

    return (
        <>
            <ClaimType headerText="What type of claim is being requested?">
                <SelectDropdown
                    id="making-claim-to"
                    label={`What will ${findPossessiveFor(values, true, true, PartOfSpeech.PRONOUN)} be making claim to?`}
                    required={true}
                    options={Object.keys(BeneficiaryMakingClaimTo).map(b => ({
                        id: b.replace(/_/g, '-').toLowerCase(),
                        text: (BeneficiaryMakingClaimTo as any)[b]
                    }))}/>
                <DateInput id="date-of-death" label="Date of death" required={false}/>
            </ClaimType>
        </>
    )
};
export default BeneficiaryClaimType;